import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { HandCoins, X } from "lucide-react";
import { api } from "@/lib/api";
import { usd } from "@/pages/team/StatementMenu";

const today = () => new Date().toLocaleDateString("en-CA");

// Owner-only, Fridays: reminds you to pay any assistant you owe. Dismissed until next Friday.
export default function PaydayReminder() {
  const key = `snaplist.payday.${today()}`;
  const [rows, setRows] = useState([]);
  const [hidden, setHidden] = useState(() => localStorage.getItem(key) === "1");
  useEffect(() => {
    if (new Date().getDay() !== 5 || hidden) return;
    api.get("/team/pay").then(({ data }) => setRows((data.members || []).filter((m) => m.owed_cents > 0))).catch(() => {});
  }, [hidden]);
  if (hidden || !rows.length) return null;
  const total = rows.reduce((t, r) => t + r.owed_cents, 0);
  const who = rows.length === 1 ? rows[0].name : `${rows.length} assistants`;
  return (
    <div className="mb-4 flex items-center gap-2 rounded-lg border border-emerald-300 bg-emerald-50 px-3 py-2 text-xs text-emerald-900" data-testid="payday-reminder">
      <HandCoins className="h-4 w-4 shrink-0 text-emerald-600" />
      <span className="min-w-0 flex-1" data-testid="payday-reminder-text">It's payday Friday. You owe <b>{who}</b> <b className="font-mono">{usd(total)}</b>.</span>
      <Link to="/dashboard" className="shrink-0 rounded-full bg-emerald-600 px-3 py-1 font-semibold text-white hover:bg-emerald-700" data-testid="payday-reminder-open">Pay now</Link>
      <button type="button" aria-label="Dismiss" onClick={() => { localStorage.setItem(key, "1"); setHidden(true); }}
        className="shrink-0 rounded p-1 text-emerald-700 hover:bg-emerald-100" data-testid="payday-reminder-dismiss"><X className="h-3.5 w-3.5" /></button>
    </div>
  );
}
